import {
    AppointmentDto,
    BookingDto,
    SaveAppointmentDto,
    SaveBookingDto
} from 'actions/bookings/BookingsDtos';
import { convertToSaveOrderDto } from 'actions/orders/OrdersConverter';
import moment from 'moment-timezone';
import { Appointment, SaveAppointment } from 'types/Appointment';
import { Booking, SaveBooking } from 'types/Booking';

export const convertToBooking = (bookingDataDto: BookingDto, timeZone: string): Booking => {
    return {
        id: bookingDataDto.id ? bookingDataDto.id : 0,
        uuid: bookingDataDto.uuid,
        customerId: bookingDataDto.customer_id,
        marketplaceId: bookingDataDto.marketplace_id,
        staffId: bookingDataDto.staff_id,
        appointments: bookingDataDto.appointments.map(appointment =>
            convertToAppointment(appointment, timeZone)
        )
    };
};

export const convertToSaveBookingDto = (newBooking: SaveBooking): SaveBookingDto => {
    return {
        uuid: newBooking.uuid,
        customer_id: newBooking.customerId,
        marketplace_id: newBooking.marketplaceId,
        staff_id: newBooking.staffId,
        appointments_attributes: newBooking.appointments.map(appointment =>
            convertToSaveAppointmentDto(appointment)
        ),
        ...(newBooking.order && {
            order: convertToSaveOrderDto(newBooking.order)
        })
    };
};

export const convertToAppointment = (
    appointmentDto: AppointmentDto,
    timeZone: string
): Appointment => {
    return {
        id: appointmentDto.id,
        uuid: appointmentDto.uuid,

        customerId: appointmentDto.customer_id,
        serviceId: appointmentDto.service_id,
        petId: appointmentDto.pet_id,
        staffId: appointmentDto.staff_id,
        addressId: appointmentDto.address_id,
        createdBy: appointmentDto.created_by,

        notes: appointmentDto.notes,
        status: appointmentDto.status,
        channel: appointmentDto.channel,

        bookedAt: moment(appointmentDto.booked_at).tz(timeZone)
    };
};

export const convertToSaveAppointmentDto = (appointment: SaveAppointment): SaveAppointmentDto => {
    return {
        uuid: appointment.uuid,

        address_id: appointment.addressId,
        customer_id: appointment.customerId,
        pet_id: appointment.petId,
        service_id: appointment.serviceId,
        staff_id: appointment.staffId,
        created_by: appointment.createdBy,

        notes: appointment.notes,
        status: appointment.status,
        channel: 'online-booking',

        booked_at: appointment.bookedAt.toISOString()
    };
};
